/**
 * DEGAP state store for registry-demo.
 */

import { create } from "zustand";

export type DegapPhase = "DECIDE" | "ENGAGE" | "GATHER" | "ARRANGE" | "PRIORITIZE";

interface DegapState {
  phase: DegapPhase;
  setPhase: (phase: DegapPhase) => void;
  
  canTransitionTo: (targetPhase: DegapPhase) => boolean;
  canRunTools: () => boolean;
  canPublishSnapshot: () => boolean;
  canEditItems: () => boolean;
  canEditCriteria: () => boolean;
  canEditItemPool: () => boolean;
}

function isValidTransition(_current: DegapPhase, _target: DegapPhase): boolean {
  // Allow any transition for now
  // Future: Add validation rules based on DEGAP spec
  return true;
}

export const useDegapStore = create<DegapState>((set, get) => ({
  phase: "DECIDE",
  
  setPhase: (phase: DegapPhase) => {
    const current = get().phase;
    if (isValidTransition(current, phase)) {
      set({ phase });
    } else {
      console.warn(`Invalid transition from ${current} to ${phase}`);
    }
  },
  
  canTransitionTo: (targetPhase: DegapPhase) => {
    return isValidTransition(get().phase, targetPhase);
  },
  
  // Invariant-based: tool execution is gated by cycle readiness (pool locked, criteria, etc.), not phase.
  canRunTools: () => true,

  canPublishSnapshot: () => true,

  canEditItems: () => true,

  canEditCriteria: () => true,

  canEditItemPool: () => true,
}));

